var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0700684 10.3432C1.6194 10.4482 2.96962 10.0852 4.21329 9.16498C3.57862 9.09148 3.02562 8.93173 2.55896 8.57548C2.10474 8.22598 1.75629 7.79023 1.56962 7.19473H2.72074C2.72696 7.16998 2.73318 7.14523 2.7394 7.11448C2.10474 6.93673 1.5634 6.61723 1.15896 6.10798C0.754513 5.60548 0.556179 5.02198 0.536735 4.38298C0.94118 4.49398 1.32696 4.60423 1.71896 4.70848C1.7314 4.68373 1.75007 4.65973 1.76251 4.63498C1.20251 4.18048 0.798068 3.63448 0.649513 2.92873C0.49617 2.24039 0.60408 1.52185 0.953624 0.903732C2.50918 2.69548 4.46218 3.68998 6.86318 3.85573C6.78851 3.27223 6.78229 2.73223 6.98762 2.20423C7.69696 0.356982 10.0855 -0.232518 11.5718 1.09348C11.7398 1.24048 11.883 1.26523 12.0634 1.20373C12.555 1.03198 13.0395 0.848232 13.5435 0.663732C13.3506 1.27123 12.9337 1.71973 12.443 2.15548C12.9213 2.03248 13.4004 1.90348 13.8733 1.78048C13.892 1.79923 13.9106 1.81123 13.9293 1.82998C13.5684 2.19823 13.22 2.58523 12.8287 2.91673C12.6172 3.09448 12.5487 3.26023 12.5363 3.53023C12.4243 6.53773 11.1736 8.96773 8.51129 10.497C5.79918 12.0495 3.00696 11.9572 0.257513 10.4782C0.207735 10.4482 0.164179 10.4107 0.0708461 10.3432H0.0700684Z",
    fill: "#E5E8EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.03c437becd0d08cceaac40a54004a1b2.svg";
export { ForwardRef as ReactComponent };